<template>
  <div class="b_typical_modal b_modal_info" v-if="smallAlert">
    <div class="b_modal_darker"></div>
    <div class="b_modal_inner">
      <div class="e_modal_xcross" @click.prevent="dialogHide()"></div>
      <div class="e_modal_titl">
        УСПЕШНО
      </div>
      <div class="e_modal_fulltext">
        <span class="m_boldr">{{ message }}</span> <br>
        <div class="m_gap_smd"></div>
        <br>
        <div class="m_gap_smd"></div>

        <a href="#" class="typical_button m_pink m_grn" @click.prevent="dialogHide()">
          <span class="typical_button_inner">Закрыть</span>
          <span class="typical_button_angle"><span class="typical_button_angle_right"></span></span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      smallAlert: false,
      message: ''
    }
  },
  methods: {
    dialogHide () {
      this.smallAlert = false
    },
    successShow (msg) {
      return new Promise((resolve, reject) => {
        if (msg) {
          this.message = msg
        } else {
          this.message = 'Данные сохранены'
        }
        this.smallAlert = true
        setTimeout(() => {
          this.smallAlert = false
          resolve()
        }, 1500)
      })
    }
  }
}
</script>

<style lang="scss">
</style>
